const error=o=>console.error(o),info=o=>console.info(o),log=o=>console.log(o),warn=o=>console.warn(o);module.exports={error:error,info:info,log:log,warn:warn};